import { createContext } from 'react'
import { CardInputError, SelectOption } from './Kanban'

export type CardContextValue = {
  projectMembers: SelectOption[]
  projectMembersForFilter: SelectOption[]
  teams: SelectOption[]
  sprints: SelectOption[]
  priorities: SelectOption[]
  prioritiesForFilter: SelectOption[]
  errors: CardInputError
}

const KanbanContext = createContext({
  projectMembers: [],
  projectMembersForFilter: [],
  teams: [],
  sprints: [],
  priorities: [],
  prioritiesForFilter: [],
  errors: new CardInputError(),
} as CardContextValue)

export default KanbanContext
